import React, { useMemo } from "react";
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";

export const Pagination = (props) => {

    const { currentPage, maxPage, setCurrentPage, maxVisiblePages } = props;

    const pages = useMemo(() => {
        const totalPages = maxPage || 1;
        const visiblePages = Math.min(totalPages, maxVisiblePages);
        const middlePage = Math.ceil(visiblePages / 2);
        let startPage = currentPage - middlePage + 1;
        if (startPage < 0) startPage = 0;
        if (startPage + visiblePages > totalPages) {
            startPage = totalPages - visiblePages;
        }
        return Array.from({ length: visiblePages }, (_, i) => i + startPage);
    }, [currentPage, maxPage, maxVisiblePages]);

    const isFirstPage = currentPage === 0;
    const isLastPage = currentPage+1 === maxPage;

    return (
        <div className="pagination">
            <div style={{padding: '10px'}}>
                <button  onClick={() => setCurrentPage(currentPage - 1)} disabled={isFirstPage}>
                    <ArrowLeftIcon
                        style={{ scale: "1.2", height: "1.5rem", width: "1.8rem" }}
                    />
                </button>
                {pages.map((page) => (
                    <button
                        id={currentPage === page? "selected": page+1}
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        style={{width:"50px"}}
                    >
                        {page + 1}
                    </button>
                ))}
                <button onClick={() => setCurrentPage(currentPage + 1)} disabled={isLastPage}>
                    <ArrowRightIcon
                        style={{ scale: "1.2", height: "1.5rem", width: "1.8rem" }}
                    />
                </button>
            </div>
        </div>
    );
};